import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { api } from '../api/client';
import { useAsync, Async } from '../components/Async';
import { MatchCard } from '../components/MatchCard';
import { ScorersList } from '../components/ScorersList';
import { H2, Muted } from '../components/ui';

const SeeAll = styled(Link)`
  display: block;
  text-align: center;
  padding: 10px;
  margin-top: 4px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.accent};
`;

const Hero = styled.div`
  background: linear-gradient(135deg, ${({ theme }) => theme.colors.accent}, #0a3d2c);
  color: #fff;
  border-radius: ${({ theme }) => theme.radius};
  padding: 18px;
  margin-bottom: 8px;
`;

const Stats = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 10px;
  font-size: 0.85rem;
  opacity: 0.95;
  strong {
    display: block;
    font-size: 1.4rem;
  }
`;

export function Home() {
  const meta = useAsync(() => api.tournament(), []);
  const today = useAsync(() => api.today(), []);
  const scorers = useAsync(() => api.scorers(), []);

  return (
    <>
      <Async state={meta}>
        {(t) => (
          <Hero>
            <div style={{ fontSize: '1.4rem', fontWeight: 800 }}>{t.name}</div>
            <Muted style={{ color: 'rgba(255,255,255,0.85)' }}>{t.host}</Muted>
            <Stats>
              <div>
                <strong>{t.played}</strong>jugados
              </div>
              <div>
                <strong>{t.remaining}</strong>por jugar
              </div>
              <div>
                <strong>{t.phase === 'group' ? 'Grupos' : 'Eliminación'}</strong>fase
              </div>
            </Stats>
          </Hero>
        )}
      </Async>

      <Async state={today}>
        {(d) => (
          <>
            {d.live.length > 0 && (
              <>
                <H2>🔴 En juego</H2>
                {d.live.map((m) => (
                  <MatchCard key={m.id} m={m} />
                ))}
              </>
            )}

            <H2>⏭️ Próximos partidos</H2>
            {d.upcoming.length === 0 ? (
              <Muted>No quedan partidos por jugar.</Muted>
            ) : (
              d.upcoming.map((m) => <MatchCard key={m.id} m={m} />)
            )}

            <H2>✅ Últimos resultados</H2>
            {d.recent.map((m) => (
              <MatchCard key={m.id} m={m} />
            ))}
          </>
        )}
      </Async>

      <H2>🥇 Goleadores</H2>
      <Async state={scorers}>
        {(d) => (
          <>
            <ScorersList scorers={d.scorers.slice(0, 8)} />
            {d.scorers.length > 8 && <SeeAll to="/scorers">Ver ranking completo →</SeeAll>}
          </>
        )}
      </Async>

      <SeeAll to="/stats">📊 Ver estadísticas del torneo →</SeeAll>
    </>
  );
}
